import React, { useEffect, lazy, Suspense } from "react";
import { useFamilyContext } from "../context/FamilyContext";
import { MdArrowBackIos } from "../utils/Icons";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

// Imports
import DashboardWrapper from "../components/DashboardWrapper";
import CustomDropdown from "../components/CustomComponents/CustomDropdown";
import CustomSelect from "../components/CustomComponents/CustomSelect";
const FamilyCard = lazy(() => import("../components/FamilyCard"));

const options = [
  { value: "self", label: "Self" },
  { value: "grandparents", label: "Grand Parents" },
  { value: "parents", label: "Parents" },
  { value: "spouse", label: "Spouse" },
  { value: "child", label: "Child" },
  { value: "sibling", label: "Sibling" },
];

const FamilyMember = () => {
  const {
    memberData,
    setMemberData,
    familyData,
    handleMemberSave,
    getMembers,
    isAddMember,
    setIsAddMember,
  } = useFamilyContext();
  const navigate = useNavigate();

  const handleAddMember = () => {
    setIsAddMember((prev) => !prev);
  };

  const handleMemberChange = (e) => {
    const { name, value } = e.target;
    setMemberData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleGenderSelect = (gender) => {
    setMemberData((prevState) => ({
      ...prevState,
      gender,
    }));
  };

  useEffect(() => {
    const token = Cookies.get("token");
    const userId = Cookies.get("userId");

    if (token && userId) {
      getMembers();
    }
  }, [getMembers]);

  return (
    <DashboardWrapper>
      <div className="w-full h-full">
        <button
          className="flex items-center font-normal text-[4vw]   mb-2 lg:hidden lg:text-[1vw] text-textPrimaryColor"
          onClick={() => navigate(-1)}
        >
          {!isAddMember &&(
            <>
            <MdArrowBackIos className="text-[5vw] lg:text-[1.5vw]" />
            <span>Back</span>
            </>
          )}
        </button>
        {familyData?.length === 0 && !isAddMember && (
          <div className="w-full h-full flex flex-col justify-between items-center">
            <div className="w-full h-[85%] flex justify-center items-center">
              <p className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
                No family members yet
              </p>
            </div>
            <button className="btn-primary" onClick={handleAddMember}>
              Add Family Member
            </button>
          </div>
        )}

      {familyData?.length > 0 && !isAddMember && (
        <div className="w-full h-full flex flex-col justify-between items-center space-y-[3%] lg:space-y-0">
          <div className="w-full flex-1 lg:max-h-[85%] grid grid-cols-1 lg:grid-cols-2 lg:gap-x-[5.5%] gap-y-2 lg:gap-y-[7.5%] overflow-x-hidden overflow-y-auto scrollbar-hide auto-rows-min">
            <Suspense
              fallback={
                <div className="w-full h-full flex justify-center items-center col-span-full">
                  <p className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
                    Loading family members...
                  </p>
                </div>
              }
            >
              {familyData?.map((family, index) => (
                <FamilyCard key={index} data={family} />
              ))}
            </Suspense>
          </div>
          <button className="btn-primary" onClick={handleAddMember}>
            Add Family Member
          </button>
        </div>
      )}

        {isAddMember && (
          <div className="w-full h-fit space-y-[3%]">
            <button
              className="flex items-center font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor"
              onClick={handleAddMember}
            >
              <MdArrowBackIos className="text-[5vw] lg:text-[1.5vw]" />
              <span>Back</span>
            </button>
            <div className="w-full h-fit space-y-[1%]">
              <span className="font-medium text-[5vw] lg:text-[1.25vw] text-textPrimaryColor">
                Family Member Information
              </span>
              <p className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
                Please provide all the details of the family member to ensure
                accurate and efficient service. Wrong information may impact the
                accuracy of the report.
              </p>
            </div>
            <div className="w-full h-fit flex flex-col lg:flex-row justify-between items-center space-y-[3%] lg:space-y-0 lg:space-x-[5%]">
              <CustomDropdown
                name="relationship"
                value={memberData.relationship}
                options={options}
                onChange={handleMemberChange}
              />
              <div className="w-full h-fit flex flex-col space-y-[2%]">
                <label
                  htmlFor="dob"
                  className="font-normal text-[1vw] text-textSecondaryColor"
                ></label>
                <input
                  type="date"
                  id="dob"
                  name="dob"
                  value={memberData?.dob}
                  onChange={handleMemberChange}
                  max={new Date().toISOString().split("T")[0]}
                  className="input-primary"
                />
              </div>
            </div>
            <div className="w-full h-fit flex flex-col lg:flex-row justify-between items-center space-y-[3%] lg:space-y-0 lg:space-x-[5%]">
              <div className="w-full h-fit flex flex-col space-y-[2%]">
                <label
                  htmlFor="name"
                  className="font-normal text-[1vw] text-textSecondaryColor"
                ></label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Member Name"
                  value={memberData?.name}
                  onChange={handleMemberChange}
                  maxLength={25}
                  className="input-primary"
                />
              </div>
              <div className="w-full h-fit flex flex-col space-y-[2%]">
                <label
                  htmlFor="contact"
                  className="font-normal text-[1vw] text-textSecondaryColor"
                ></label>
                <input
                  type="number"
                  id="contact"
                  name="contact"
                  placeholder="Mobile Number"
                  value={memberData?.contact}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 10) {
                      handleMemberChange(e);
                    }
                  }}
                  max={9999999999}
                  onKeyDown={(e)=>{
                    if(['e', 'E', '+', '-', '.'].includes(e.key)){
                      e.preventDefault();
                    }
                  }}
                  className="input-primary"
                />
              </div>
            </div>
            <CustomSelect
              dataArray={["male", "female", "other"]}
              onSelect={handleGenderSelect}
              selectedItem={memberData.gender}
            />
            {memberData.relationship?.length > 0 &&
            memberData?.dob?.length > 0 &&
            memberData?.name?.length > 0 &&
            memberData?.contact?.toString().length === 10 &&
            memberData.gender?.length > 0 ? (
              <button
                className="btn-primary"
                style={{ marginTop: "5%" }}
                onClick={() => handleMemberSave(memberData)}
              >
                Save Member
              </button>
            ) : (
              <button
                disabled
                className="btn-secondary"
                style={{ marginTop: "5%" }}
              >
                Save Member
              </button>
            )}
          </div>
        )}
      </div>
    </DashboardWrapper>
  );
};

export default FamilyMember;
